module.exports = __webpack_public_path__ + "img/carousel-vet-4.a7d1b01d.jpg";